import type { ReactNode } from 'react';

export const symbol_self_improvement: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M261-160q-26 0-43-17t-17-43q0-18 9-34.5t26-23.5l172-68v-138q-60 73-121.5 114T150-322q-12 2-21-7t-9-22q0-12 8.5-21t20.5-11q58-7 107-37t89-81l58-65q10-12 23.5-20t29.5-8h48q16 0 30 8t24 20l58 65q42 49 90 80t105 38q12 2 20.5 11t8.5 21q0 13-9 22t-21 7q-75-7-136.5-48T552-484v138l172 68q17 7 26 23.5t9 34.5q0 26-17 43t-43 17H396v-11q0-26 16-42t42-16h133q8 0 14-6t6-14q0-8-6-14t-14-6H454q-44 0-70 27t-26 71v11h-97Zm167.5-515.5Q407-697 407-727t21.5-51.5Q450-800 480-800t51.5 21.5Q553-757 553-727t-21.5 51.5Q510-654 480-654t-51.5-21.5Z"
		/>
	</svg>
);
